import logo from "./logo.svg";
import "./App.css";
import { Landingpage } from "./landingpage";
import Loginpage from "./loginpage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Tfcdata from "./tfcdata";

function App() {
	return (
		<div className="App">
			<Router>
				<Routes>
					<Route path="/" element={<Landingpage />}></Route>
					<Route path="/login" element={<Loginpage />}></Route>
					<Route path="/tfcdata" element={<Tfcdata />}></Route>
				</Routes>
			</Router>
			{/* <Landingpage></Landingpage> */}
			{/* <Loginpage></Loginpage> */}
		</div>
	);
}

export default App;
